import { put, call, take, select, fork } from 'redux-saga/effects'
import { showNotification } from '../../../app/actions'
import { actionNames } from './actions'
import { fetchCountries } from './api'

const getCountries = (state) => state.countries

function* fetchCountriesWorker() {
  try {
    const { countries } = yield call(fetchCountries)
    yield put({
      type: actionNames.FETCH_COUNTRIES_SUCCESS,
      countries,
    })
  } catch (err) {
    yield put({ type: actionNames.FETCH_COUNTRIES_FAILURE })
    yield put(
      showNotification({
        type: 'error',
        message: 'Countries data could not be loaded.',
      })
    )
  }
}

function* watchFetch() {
  yield take(actionNames.FETCH_COUNTRIES)
  const countries = yield select(getCountries)

  if (countries.length > 0) {
    yield put({ type: actionNames.FETCH_COUNTRIES_LOADED })
  } else {
    yield fork(fetchCountriesWorker)
  }
}

export default [watchFetch]

export { watchFetch }
